/**
 * "Continue with LinkedIn", then Google / Microsoft / Apple — the top of the
 * first step of /login and /signup. Renders `useSocialSignInPanel`.
 */
import { AlertCircle } from '@tonnie/assets';
import { useSocialProviderLabels } from '@tonnie/locale';
import { Alert, AlertDescription, SocialSignInButtons } from '@tonnie/ui';

import { useSocialSignInPanel } from './use-social-sign-in-panel';

export function SocialSignInSection({ mode }: { mode: 'sign-in' | 'sign-up' }) {
  const labels = useSocialProviderLabels();
  const { providers, ready, pending, error, select } = useSocialSignInPanel(mode);

  return (
    <div className="space-y-4">
      {error && (
        <Alert variant="destructive" data-testid="auth-social-error">
          <AlertCircle className="h-4 w-4" aria-hidden="true" />
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}
      <SocialSignInButtons
        providers={providers}
        labels={labels}
        onSelect={select}
        pending={pending}
        disabled={!ready}
        testIdPrefix={mode === 'sign-in' ? 'auth-login-oauth' : 'auth-signup-oauth'}
      />
    </div>
  );
}
